import { Component } from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { History } from "history";
import {
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    Dropdown,
    PrimaryButton,
    TextField,
} from "office-ui-fabric-react";
import AbsoluteLoader from '../Loader/AbsoluteLoader';
import { RootState } from "app/redux/reducer";
import { setModalData, toggleModal } from "app/redux/modal/actions";
import { createSpecification, getSpecifications, getSpecificationTypes, updateSpecification } from "app/services/specification";
import { castThunkAction } from "app/utils/casting";

interface OwnProps {
    history: History<any>;
}

function mapStateToProps(state: RootState) {
    return {
        ...state.modal.specification,
        specificationTypes: state.specification.specificationTypes,
        language: state.system.language,
        modalLoading: state.system.modalLoading
    };
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        ...bindActionCreators(
            {
                setModalData,
                toggleModal,
                createSpecification,
                getSpecifications,
                updateSpecification,
                getSpecificationTypes
            },
            dispatch
        ),
    };
}

type SpecificationModalProps = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps> &
    OwnProps;

class SpecificationModal extends Component<SpecificationModalProps> {

    UNSAFE_componentWillReceiveProps(nextProps: SpecificationModalProps) {
        if (this.props.show !== nextProps.show && nextProps.show) {
            this.props.getSpecificationTypes({ page: 1, pageSize: 100, descending: false });
        }
    }

    onClose() {
        if (this.props.callback) {
            this.props.callback()
        }
        this.props.toggleModal("specification", {});
    }

    onSave() {
        castThunkAction(this.props.data.id ? this.props.updateSpecification(this.props.data) : this.props.createSpecification(this.props.data)).then(res => {
            if (res) {
                this.props.getSpecifications({ page: 1, pageSize: 1000, descending: false });
                this.onClose();
            }
        })
    }

    onChangeData(key: string, value: any) {
        this.props.setModalData("specification", {
            ...this.props.data,
            [key]: value
        })
    }

    renderForm() {
        return (
            <div className="modal-form">
                <div className="row reverse-margin">
                    <div className="item col-md-12">
                        <TextField
                            placeholder="Spesifikasyon Adı"
                            value={this.props.data.title || ""}
                            label="Spesifikasyon Adı"
                            className="custom-textfield border"
                            onChange={(event: any) => this.onChangeData("title", event.target.value)}
                        />
                    </div>
                    <div className="item col-md-12">
                        <TextField
                            placeholder="Spesifikasyon Sırası"
                            value={this.props.data?.order?.toString() || "0"}
                            label="Spesifikasyon Sırası"
                            type="number"
                            className="custom-textfield border"
                            onChange={(event: any) => this.onChangeData("order", parseInt(event.target.value))}
                        />
                    </div>
                    <div className="item col-md-12">
                        <Dropdown
                            selectedKey={this.props.data?.specificationTypeId || ""}
                            label="Spesifikasyon Kategorisi"
                            calloutProps={{ className: "custom-dropdown-callout" }}
                            className="custom-dropdown border"
                            onChange={(event: any, option) => this.onChangeData("specificationTypeId", option?.key as string)}
                            options={(this.props.specificationTypes?.list || []).map(item => ({ key: item.id, text: item.title }))}
                        />
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { data, show, modalLoading } = this.props;

        if (!show) return null;

        return (
            <Dialog
                hidden={!show}
                onDismiss={() => this.onClose()}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: data.id ? "Spesifikasyon Düzenle" : "Yeni Spesifikasyon Ekle",
                    closeButtonAriaLabel: "Kapat",
                    subText:
                        "Aşağıdaki bilgileri doldurarak belirlediğiniz kriterlerde bir spesifikasyon ekleyin ya da düzenleyin."
                }}
                modalProps={{
                    className: "confirm",
                    isBlocking: true,
                    styles: { main: { maxWidth: "1000px !important" } },
                }}
            >
                <AbsoluteLoader show={modalLoading} />
                {this.renderForm()}
                <DialogFooter>
                    <DefaultButton
                        onClick={() => this.onClose()}
                        text="İptal"
                    />
                    <PrimaryButton
                        onClick={() => this.onSave()}
                        text={data.id ? "Güncelle" : "Ekle"}
                        disabled={(!data.title || modalLoading) ? true : false}
                    />
                </DialogFooter>
            </Dialog>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecificationModal);
